import cx from 'classnames'
import React from 'react'
import { v4 as uuid } from 'uuid'
import { Row } from '../Grid'
import './styles.scss'

interface HorizontalListProps {
  separator?: React.ReactNode
  items: React.ReactNode[]
  className?: string
}

export function HorizontalList({ items, separator, className }: HorizontalListProps) {
  return (
    <Row>
      <div className={cx('app-horizontal-list', 'u-flex-align-center u-flex-wrap', className)}>
        {items.map((item, i) => (
          <React.Fragment key={uuid()}>
            {item}
            {separator && i === items.length - 1 ? (
              <div className="u-margin-right--medium" />
            ) : (
              <span className="u-margin-horizontal--small">{separator}</span>
            )}
          </React.Fragment>
        ))}
      </div>
    </Row>
  )
}

export default HorizontalList
